<template>
  <section v-if="paginationCount > 0">
    <div id="page-info">
      第{{ pageStart }} ~
      {{ pageEnd }}条记录，共{{ paginationCount }}条记录
    </div>
    <el-pagination
      :current-page="pageNumber"
      background
      layout="prev, pager, next"
      :page-size="pageSizeNumber"
      :total="paginationCount"
      @current-change="pageChange"
    >
    </el-pagination>
  </section>
</template>
<script>
export default {
  props: {
    page: {
      type: [Number, String],
      default: 1
    },
    pageSize: {
      type: [Number, String],
      default: 10
    },
    count: {
      type: [Number, String],
      default: 0
    }
  },
  computed: {
    pageNumber() {
      return Number(this.page) || 1;
    },
    pageSizeNumber() {
      return Number(this.pageSize) || 10;
    },
    paginationCount() {
      return Number(this.count) || 0;
    },
    pageStart() {
      return (this.pageNumber - 1) * this.pageSizeNumber + 1;
    },
    pageEnd() {
      return Math.min(this.pageNumber * this.pageSizeNumber, this.paginationCount);
    }
  },
  methods: {
    // 切换页码时只向父组件抛出页码，查询条件由父组件统一维护。
    pageChange(val) {
      this.$emit("pageChange", val);
    }
  }
};
</script>
<style lang="less" scoped>
#page-info {
  float: left;
  color: #727272;
  font-size: 12px;
  padding-top: 5px;
}
.el-pagination {
  text-align: right;
  padding: 0;
  // padding-bottom: 10px;
}
</style>
<style lang="less">
#app {
  .el-pagination.is-background .btn-next,
  .el-pagination.is-background .btn-prev,
  .el-pagination.is-background .el-pager li {
    margin: 0;
  }
  .el-pagination.is-background .btn-next,
  .el-pagination.is-background .btn-prev,
  .el-pagination.is-background .el-pager li {
    min-width: 32px;
    height: 32px;
    line-height: 32px;
    background: #ffffff;
    border: 1px solid #ececec;
    font-size: 12px;
    color: #4a4a4a;
  }
  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background: #f7f7f7;
    border: 1px solid #ececec;
    font-size: 12px;
    color: #4a4a4a;
  }
}
</style>
